import React from 'react';
import { MappingInsightData, MappingGoal } from './mappingTypes';
import { getMappingStyles } from './mappingStyles';
import { useDarkMode } from '../../../context/DarkModeContext';

interface MappingInsightsProps {
  insights: MappingInsightData;
  selectedGoal: MappingGoal | null;
  className?: string;
}

const MappingInsights: React.FC<MappingInsightsProps> = ({
  insights,
  selectedGoal,
  className = ''
}) => {
  const { darkMode } = useDarkMode();
  const styles = getMappingStyles(darkMode);

  return (
    <div className={`grid grid-cols-2 gap-4 ${className}`}>
      <div className={`${styles.cardBg} rounded-lg p-4`}>
        <h4 className={`text-sm font-medium ${styles.mutedTextColor} mb-2`}>Goal Alignment</h4>
        <p className={`text-2xl font-semibold ${styles.textColor} mb-1`}>
          {insights.alignmentStatus === 'perfect' ? '🎯 Perfect' : 
           insights.alignmentStatus === 'good' ? '🎯 Well-aligned' : 
           '⚠️ Needs work'}
        </p>
        <p className={`text-xs ${styles.mutedTextColor}`}>
          {selectedGoal ? 
            `Your "${selectedGoal.text}" goal ${
              insights.alignmentStatus === 'perfect' ? 'covers all criteria' :
              'connects well with evaluation criteria'
            }` : 
            'Select a goal to see alignment'
          }
        </p>
      </div>

      <div className={`${styles.cardBg} rounded-lg p-4`}>
        <h4 className={`text-sm font-medium ${styles.mutedTextColor} mb-2`}>Unmapped Criteria</h4>
        <p className={`text-2xl font-semibold ${styles.textColor} mb-1`}>
          📋 {insights.unmappedCount} items
        </p>
        <p className={`text-xs ${styles.mutedTextColor}`}>
          {insights.unmappedCount === 0 ? 
            'All criteria have connected goals' :
            insights.unmappedItems.length > 0 ?
              `"${insights.unmappedItems.join('", "')}${insights.unmappedCount > 2 ? '...' : ''}" have no connected goals` :
              'Some criteria have no connected goals'
          }
        </p>
      </div>
    </div>
  );
};

export default MappingInsights;